import { DateTime } from 'luxon';
import * as React from 'react';

interface IDateText {
  date: string | null;
}

const DateText: React.FunctionComponent<IDateText> = (props) => {
  return props.date !== null && DateTime.fromISO(props.date).isValid ? (
    <span>{DateTime.fromISO(props.date).toFormat('LLL dd, yyyy')}</span>
  ) : (
    <span>None</span>
  );
};

export default DateText;
